export const airWeightBrackets = {
  lt45: "weightPriceLt45",
  gt45: "weightPriceGt45",
  gt100: "weightPriceGt100",
  gt300: "weightPriceGt300",
  gt500: "weightPriceGt500",
  gt1000: "weightPriceGt1000",
};

export const airWeightBracketsTotals = {
  lt45: "totalWeightPriceLt45",
  gt45: "totalWeightPriceGt45",
  gt100: "totalWeightPriceGt100",
  gt300: "totalWeightPriceGt300",
  gt500: "totalWeightPriceGt500",
  gt1000: "totalWeightPriceGt1000",
};
